import { Component, ViewContainerRef } from '@angular/core';
import { Page } from '../../models/static-page/page-model';
import { PageService } from '../../services/static-page/page.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { CategoryService } from '../../services/category/category.service';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-edit-page',
    templateUrl: './edit-page.component.html',
    styleUrls: ['./edit-page.component.css']
})
/** edit-page component*/
export class EditPageComponent {
  /** edit-page ctor */
  public page = new Page();
  public longDetail: any;
  public websiteName: string;
  validate: boolean;
  isUnique = true;
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  constructor(private readonly pageService: PageService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private _avRoute: ActivatedRoute, private readonly categoryService: CategoryService, private readonly rolePermissionService: RolePermissionService) {
    this.checkPermission();
    this.page.metaKeyword = "";
    this.page.metaDescription = "";
    this.page.metaTitle = "";
    if (this._avRoute.snapshot.params["id"]) {
      this.getPageById(this._avRoute.snapshot.params["id"]);
      this.toastr.setRootViewContainerRef(vcr);
      this.validate = true;
    }
    this.GetSystemSettingFirstOrDefault();
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("staticpage").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
          }
          else {
            this.router.navigate(["/page-list"]);
          }
        }
        else {
          this.router.navigate(["/page-list"]);
        }
      }
    )
  }
  GetSystemSettingFirstOrDefault() {
    this.categoryService.GetSystemSettingFirstOrDefault().subscribe(
      data => {
        this.websiteName = data.siteUrl + "/about";
      });
  }
  getPageById(id: string) {
    this.pageService.getPageById(id).subscribe(
      data => {
        this.page = data;
        setTimeout(() => {
          this.longDetail = this.page.detail;
        }, 2000);
        if (this.page.metaDescription == "" || this.page.metaDescription == null) {
          this.page.metaDescription = "";
        }
        if (this.page.metaKeyword == "" || this.page.metaKeyword== null) {
          this.page.metaKeyword = "";
        }
        if (this.page.metaTitle == "" || this.page.metaTitle ==null) {
          this.page.metaTitle = "";
        }
      }
    )
  }
  onTextChange(Value: string) {

    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "-");
    }
    this.page.url = Value.toLowerCase();
  }
  isActiveCheckbox(e) {
    this.page.isActive = e.target.checked;
  }
  onSubmit() {
    this.pageService.isUniqueUrl(this.page.url, this.page.pageId).subscribe(
      data => {
        if (data == true) {
          this.isUnique = true;
          this.validate = false;
          this.page.detail = this.longDetail;
          this.pageService.updatePage(this.page).subscribe(result => {
            if (result) {
              this.toastr.success('Static page has been Updated.', 'Success');
              setTimeout(() => {
                this.router.navigate(["/page-list"]);
              }, 1000);
            }
            else {
              this.toastr.error('Error occurred. Please try again', 'Error');
            }
          });
        }
        else {
          this.isUnique = false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/static-page/edit-page/edit-page.component.ts